module.exports = __webpack_public_path__ + "assets/5c1c53e0824e8d226794136301fca581.svg";